import React from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { turkishCurrencyFormatterNoPrecision } from "../utils";
import LoadingBox from "./LoadingBox";

export default function SepetItemEditor(props) {
  const {
    showAddCard,
    setShowAddCard,
    decrementProductItemHandler,
    incrementProductItemHandler,
    item,
    loadingUpdate,
    index,
    removeItemHandler,
    ikramEtHandler,
    setShowDivideItem,
    setDivideFirstPart,
    setDivideSecondPart,
    ozetle,
    setShowChangePrice,
    setSelectedProductPrice,
    setSelectedProduct,
    setShowAnswerDetails,
    setAnswers,
    isMenuItem,
  } = props;
  return (
    <Modal size="sm" show={showAddCard} onHide={() => setShowAddCard(false)}>
      <Modal.Header closeButton>
        <Modal.Title>
          {loadingUpdate ? (
            <div style={{ display: "inline-block" }} className="ms-2">
              <LoadingBox />
            </div>
          ) : (
            <>
              {item.quantity + " "}
              <span>{!!item.feature && item.feature.name}</span>
              &nbsp;<span>{item.name}</span>
              &nbsp;
              <span>
                {turkishCurrencyFormatterNoPrecision(
                  item.quantity *
                    (item.price + (item.feature ? item.feature.price : 0))
                )}
              </span>
            </>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {(!item.answers || item.answers.length === 0) &&
            !item.relativeItem && (
              <>
                <Button
                  style={{
                    width: "120px",
                    aspectRatio: "2/1",
                    margin: "0.3rem",
                  }}
                  disabled={loadingUpdate}
                  variant="outline-danger"
                  onClick={() => decrementProductItemHandler(item, index, 1)}
                >
                  <h4>
                    <i className="fas fa-minus"></i>
                    &nbsp;1
                  </h4>
                </Button>

                <Button
                  style={{
                    width: "120px",
                    aspectRatio: "2/1",
                    margin: "0.3rem",
                  }}
                  variant="outline-success"
                  onClick={() => incrementProductItemHandler(item, index, 1)}
                  disabled={loadingUpdate}
                >
                  <h4>
                    <i className="fas fa-plus"></i>
                    &nbsp;1
                  </h4>
                </Button>
              </>
            )}
          {item.isHalfPortion &&
            (!item.answers || item.answers.length === 0) &&
            !item.relativeItem && (
              <>
                <Button
                  style={{
                    width: "120px",
                    aspectRatio: "2/1",
                    margin: "0.3rem",
                  }}
                  disabled={loadingUpdate}
                  variant="outline-danger"
                  onClick={() => decrementProductItemHandler(item, index, 0.5)}
                >
                  <h4>
                    <i className="fas fa-minus"></i>
                    &nbsp;1/2
                  </h4>
                </Button>

                <Button
                  style={{
                    width: "120px",
                    aspectRatio: "2/1",
                    margin: "0.3rem",
                  }}
                  disabled={loadingUpdate}
                  variant="outline-success"
                  onClick={() => incrementProductItemHandler(item, index, 0.5)}
                >
                  <h4>
                    <i className="fas fa-plus"></i>
                    &nbsp;1/2
                  </h4>
                </Button>
              </>
            )}

          <Button
            style={{
              width: "calc(240px + 0.6rem)",
              aspectRatio: "4/1",
              margin: "0.3rem",
            }}
            variant="outline-danger"
            disabled={loadingUpdate}
            onClick={async () => {
              await removeItemHandler(item, index);
              setShowAddCard(false);
            }}
          >
            <div className="text-bold">
              <span>Sil</span>
            </div>
          </Button>

          <Button
            style={{
              width: "calc(240px + 0.6rem)",
              aspectRatio: "4/1",
              margin: "0.3rem",
            }}
            disabled={loadingUpdate}
            variant="outline-danger"
            onClick={() => {
              ikramEtHandler(item.itemCode, !item.isGift);
            }}
          >
            <div className="text-bold">
              <span>{item.isGift ? "İkram İptal Et" : "İkram Et"}</span>
            </div>
          </Button>
          {(!item.answers || item.answers.length === 0) &&
            !item.relativeItem &&
            item.quantity > 1 && (
              <Button
                style={{
                  width: "calc(240px + 0.6rem)",
                  aspectRatio: "4/1",
                  margin: "0.3rem",
                }}
                disabled={loadingUpdate}
                variant="dark"
                onClick={() => {
                  if (item.isPartialPaid) {
                    toast.error("Ödendi, değişiklik yapılmaz!");
                    return;
                  }
                  if (ozetle) {
                    toast.info(
                      "Bu işlemi yapmak için özet modundan çıkmalısınız"
                    );
                  } else {
                    setSelectedProduct(item);
                    setDivideFirstPart(item.quantity - 1);
                    setDivideSecondPart(1);
                    setShowAddCard(false);
                    setShowDivideItem(true);
                  }
                }}
              >
                <div className="text-bold">
                  <span>Siparişi Böl</span>
                </div>
              </Button>
            )}

          <Button
            style={{
              width: "calc(240px + 0.6rem)",
              aspectRatio: "4/1",
              margin: "0.3rem",
            }}
            disabled={loadingUpdate}
            variant="dark"
            onClick={() => {
              if (item.isPartialPaid) {
                toast.error("Ödendi, değişiklik yapılamaz!");
                return;
              }
              if (ozetle) {
                toast.info("Bu işlemi yapmak için özet modundan çıkmalısınız");
              } else {
                setShowChangePrice(true);
                setSelectedProduct(item);
                setSelectedProductPrice(
                  (item.feature ? item.feature.price : 0) + item.price
                );
                setShowAddCard(false);
              }
            }}
          >
            <div className="text-bold">
              <span>Fiyat Değiştir</span>
            </div>
          </Button>
          {item.answers?.length > 0 && (
            <Button
              style={{
                width: "calc(240px + 0.6rem)",
                aspectRatio: "4/1",
                margin: "0.3rem",
              }}
              disabled={loadingUpdate}
              variant="dark"
              onClick={() => {
                setShowAddCard(false);
                setSelectedProduct(item);
                setShowAnswerDetails(true);
                setAnswers(item.answers);
              }}
            >
              <div className="text-bold">
                <span>Müşteri Tercihleri</span>
              </div>
            </Button>
          )}

          <Button
            style={{
              width: "calc(240px + 0.6rem)",
              aspectRatio: "4/1",
              margin: "0.3rem",
            }}
            disabled={loadingUpdate}
            variant="outline-success"
            onClick={() => {
              setShowAddCard(false);
            }}
          >
            <div className="text-bold">
              <span>Kapat</span>
            </div>
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
